




// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'CheckState',  
  props: {
    checked:{
      type:Boolean,
      required:true,
      default:false
    },
    small:{
      type:Boolean,
      required:false,
      default:false
    },
    trueText:{
      type:String,
      default:"oui"
    },
    falseText:{
      type:String,
      default:"non"
    },
    showText:{
      type:Boolean,
      default:true
    }
  }
})
export default class CheckState extends Vue {
  checked!:boolean
  small!:boolean
}
